import { REQUEST_METHODS } from '@/constants/network'
import baseFetch from '@/network/baseFetch'

export const getEmiPrice = (payload: any) => {
  const response = baseFetch({
    url: `/emi/eligibility`,
    method: REQUEST_METHODS.POST,
    body: JSON.stringify(payload),
  })
  return response
}

export const getEmiBanksList = (payload: any) => {
  const response = baseFetch({
    url: `/emi/affordability`,
    method: REQUEST_METHODS.POST,
    body: JSON.stringify(payload),
  })
  return response
}
